var _defs, _path, _defs2, _rect, _linearGradient, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAimaxFaviconColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8046875,0,0,0.8046875,12.54339021915635,5.667333039592144)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52 59",
    "data-background-color": "#000000",
    preserveAspectRatio: "xMidYMid meet",
    height: 145,
    width: 128,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,-0.02190574171000037,-0.0036289999999894462)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52.043811483419994 59.00725799999999",
    height: 59.00725799999999,
    width: 52.043811483419994,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52.043811483419994 59.00725799999999",
    height: 59.00725799999999,
    width: 52.043811483419994,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52.043811483419994 59.00725799999999",
    height: 59.00725799999999,
    width: 52.043811483419994,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52.043811483419994 59.00725799999999",
    height: 59.00725799999999,
    width: 52.043811483419994,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52.043811483419994 59.00725799999999",
    height: 59.00725799999999,
    width: 52.043811483419994,
    id: "textblock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52.043811483419994 59.00725799999999",
    height: 59.00725799999999,
    width: 52.043811483419994,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52.043811483419994 59.00725799999999",
    height: 59.00725799999999,
    width: 52.043811483419994,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "5.9 0 88.199 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    height: 59.00725799999999,
    width: 52.043811483419994,
    className: "icon-icon-0",
    "data-fill-palette-color": "accent",
    id: "icon-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))))))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("mask", {
    id: "9acba00a-27db-487c-85ba-242edc371501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG2074"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52.043811483419994 59.00725799999999",
    height: 59.00725799999999,
    width: 52.043811483419994,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52.043811483419994 59.00725799999999",
    height: 59.00725799999999,
    width: 52.043811483419994,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52.043811483419994 59.00725799999999",
    height: 59.00725799999999,
    width: 52.043811483419994,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52.043811483419994 59.00725799999999",
    height: 59.00725799999999,
    width: 52.043811483419994,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG2073"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52.043811483419994 59.00725799999999",
    height: 59.00725799999999,
    width: 52.043811483419994,
    id: "SvgjsSvg2072",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52.043811483419994 59.00725799999999",
    height: 59.00725799999999,
    width: 52.043811483419994,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52.043811483419994 59.00725799999999",
    height: 59.00725799999999,
    width: 52.043811483419994,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "5.9 0 88.199 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    height: 59.00725799999999,
    width: 52.043811483419994,
    className: "icon-icon-0",
    "data-fill-palette-color": "accent",
    id: "SvgjsSvg2071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9 9.777C5.9 4.377 10.276 0 15.676 0c1.677 0 2.74 0.438 4.61 1.182l68.577 39.9c3.189 1.89 4.666 4.927 5.236 8.428v0.982c-0.57 3.499-2.047 6.537-5.236 8.428L20.287 98.819c-1.871 0.745-2.934 1.181-4.61 1.181-5.4 0-9.776-4.377-9.776-9.777V9.777z",
    fill: "white"
  })))))))))))))))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", null)))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52.043811483419994,
    height: 59.00725799999999,
    fill: "black",
    stroke: "none",
    visibility: "hidden"
  })))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0.578,
    y2: 0.595,
    id: "d569387a-0041-4c16-b683-654683df5a4b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ee2f5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6454f0",
    offset: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 52.043811483419994,
    height: 59.00725799999999,
    fill: "url(#d569387a-0041-4c16-b683-654683df5a4b)",
    mask: "url(#9acba00a-27db-487c-85ba-242edc371501)",
    "data-fill-palette-color": "accent"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 52.043811483419994,
    height: 59.00725799999999,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAimaxFaviconColor);
export default __webpack_public_path__ + "static/media/aimax-favicon-color.45c6b1c6cb8b4cbc3f055b132d2519e7.svg";
export { ForwardRef as ReactComponent };